module.exports = __webpack_public_path__ + "static/hill4-4d480c87e85fffbbe7122462eb6dad0b.svg";